export default __webpack_public_path__ + "static/media/areas.b4979f3b.svg";